<script setup lang="ts">
import { routes } from "/assets/routes.ts";
import { useWindowSize } from "@vueuse/core";
const { width: windowW } = useWindowSize();
const headers = ref(null);
const { width: headersW } = useElementSize(headers);
import { useElementSize } from "@vueuse/core";

const route = useRoute();
const page = route.path.split("/")[1];
const thisHeader = computed(() => {
  return qsDecode(route.path.split("/")[2]);
});
const thisIndex = computed(() => {
  return Array.from(Object.keys(routes[page])).indexOf(thisHeader.value);
});

const hasSubheader = function (route: string) {
  return routes[page][route][0] !== undefined;
};
const headerOffset = computed(() => {
  if (windowW.value > 800) return thisIndex.value * -15 + "vh";
  if (thisIndex.value === 0) return 0;
  // measure current header width
  const totalHeaders = Array.from(Object.keys(routes[page]));
  const baseCh = 20;
  const baseGap = 8;
  const leftPadding = 16;
  const currentHeaderWidth = thisHeader.value.length * baseCh + leftPadding;

  //get desired offset
  const offset = (windowW.value - currentHeaderWidth) / 2;

  //calculate translateX to the left of current header
  const headersToLeft = totalHeaders.slice(0, thisIndex.value);
  const gaps = headersToLeft.length - 1;
  const leftLength =
    headersToLeft.join("").length * baseCh + gaps * baseGap + leftPadding;

  // return translateX - offsetw-screen overflow-hidden
  if (leftLength - offset < 0) return "-20px";
  return -(leftLength - offset) + "px";
});
</script>

<template>
  <div class="w-screen overflow-y-auto" style="height: calc(100vh - 3.5rem)">
    <nav
      id="headers"
      v-if="header !== 'admin'"
      class="header flex whitespace-nowrap gap-6 mb-3 h-12 w-full overflow-y-visible [@media(max-width:767px)]:scrollbar-hide page-padding-x transition-all duration-300 ease"
      :style="`transform: translateX(${headerOffset});`"
    >
      <nuxt-link
        v-for="header in Array.from(Object.keys(routes[page]))"
        :key="header"
        :class="header === thisHeader ? 'opacity-100' : 'opacity-40'"
        :to="
          hasSubheader(header)
            ? `/${qsEncode(page)}/${qsEncode(header)}/${qsEncode(
                routes[page][header][0],
              )}`
            : `/${qsEncode(page)}/${qsEncode(header)}`
        "
        >{{ header }}
      </nuxt-link>
    </nav>
    <div id="header-slot" class="w-screen overflow-x-visible">
      <slot></slot>
    </div>
  </div>
</template>

<style>
#header-slot div {
  /* min-height: calc(100vh - 3rem); */
}

.header-left-enter-active,
.header-right-enter-active,
.header-left-leave-active,
.header-right-leave-active {
  position: fixed;
  /* top: 6.21875rem; */
  left: 0;
  right: 0;
  transition:
    transform 250ms cubic-bezier(0.3, 0.62, 0.64, 0.99),
    opacity 100ms 200ms ease-in;
  width: 100vw;
  left: -1.5rem;
  right: 0;
  padding: 0 1.5rem;
  transition:
    transform 250ms ease-out,
    opacity 100ms 200ms ease-in;
  width: 100vw;
  @media (min-width: 768px) {
    left: -4rem;
    padding: 0 4rem;
  }
}

.header-left-enter-from,
.header-right-leave-to {
  transform: translateX(100%);
}

.header-left-leave-to,
.header-right-enter-from {
  transform: translateX(-100%);
}

.header-left-enter-to,
.header-right-enter-to {
  transform: translateX(1.5rem);
}
.header-left-leave-from,
.header-right-leave-from {
  transform: translateX(1.5rem); /* Or another desired value */
}
</style>
